import { useLoggedOutSuppliersLayoutElementResponse } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersLayoutElement/__internal__/useLoggedOutSuppliersLayoutElementResponse";

export const useLoggedOutSuppliersLayoutElementRequestId = () => {
  const { data } = useLoggedOutSuppliersLayoutElementResponse();
  return data?.request_id ?? "";
};
